export default "__VITE_ASSET__CFSbz$NM__"